export default __webpack_public_path__ + "static/image21-5b870d0115cab83cf877605fa8e6cb1d.gif";